"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
const borsher_1 = require("borsher");
const buffer_1 = require("buffer");
class Parser {
    parse;
    constructor(parse) {
        this.parse = parse;
    }
    static json() {
        return new Parser((buffer) => JSON.parse(buffer_1.Buffer.from(buffer).toString()));
    }
    static borsh(schema) {
        return new Parser((buffer) => (0, borsher_1.borshDeserialize)(schema, buffer));
    }
    static custom(parse) {
        return new Parser(parse);
    }
}
exports.Parser = Parser;
//# sourceMappingURL=Parser.js.map